export const MAX_AMOUNT = 99999;
// Maximum possible id number for non-exotic/picks wager types
export const WAGER_TYPE_LIMIT = 70;
